export const generateAPIEvent=function(){
    const event=new Event("api-call-triggered");
    window.dispatchEvent(event);
  }